<template>
  <div class="login">
    <div class="backgroundImg">
      <img class="loginPhoto" src="@/assets/photo.png"  alt="">
    </div>
    <div v-if="!urlParams" class=loginContent>
      <p>学校端</p>
      <div class="remark">
        <p>
          <a href="https://www.lvluoxinli.com/static/html/guide.html" target="_blank"
            style="color:#999999">用户服务指南</a>&nbsp;&nbsp;&nbsp;
          <a href="https://www.lvluoxinli.com/static/html/clause.html" target="_blank"
            style="color:#999999">使用条款和隐私政策</a>&nbsp;&nbsp;&nbsp;
          服务邮箱：lvluoxinli@dingtalk.com
        </p>
        <p>
          ©2019 绿萝心理版权所有&nbsp;&nbsp;&nbsp;
          京ICP备18051758号-2 &nbsp;&nbsp;&nbsp;
          <i class="jgwablogo"></i>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008381" target="_blank"
            style="color:#999999">京公网安备11010202008381</a>
        </p>
      </div>
      <div class="ContentFrom">
        <p>你好</p>
        <p>欢迎使用河南省中小学心理健康云平台</p>
        <p>填写以下信息登录</p>
        <div class="form">
          <a-form status-icon class="demo-ruleForm" align="center">
            <!-- <div class="formItem" v-for="(item, index) in formData" :key="index"> -->
            <a-form-item prop="name">
              <a-input auto-complete="off" v-model="username" placeholder="请输入账号"></a-input>
            </a-form-item>
            <!-- </div> -->
            <a-form-item prop="pass">
              <a-input type="password" auto-complete="off" v-model="password" placeholder='请输入密码'
                @keyup.enter.native="userLogin"></a-input>
            </a-form-item>
          </a-form>
          <div class="loginIn">
            <a-button type="primary" :plain="true" @click="userLogin" :disabled="loginDisable">登录</a-button>
          </div>
        </div>

        <div class="outerLogin flex-row justify-between">
          <div class="section_2 flex-col"></div>
          <span class="text_8">其他登录方式</span>
          <div class="section_3 flex-col"></div>
        </div>

        <div class="block_2 flex-row" @click="openLink">
          <div class="image-text_1 flex-row justify-between">
            <img class="label_1" referrerpolicy="no-referrer"
              src="@/assets/weixn.png" />
            <span class="text-group_1">微信登录</span>
          </div>
        </div>

      </div>
      <a-modal title="微信登录" v-model="qr" footer="">
        <iframe v-if="qr" name="wxIframe"
          style="width: 100%;"
          src='https://open.weixin.qq.com/connect/qrconnect?appid=wx13fce24cf56abac9&self_redirect=true&scope=snsapi_login&redirect_uri=https://mp.api.lvluoxinli.com/api/user/oplatform/report?cb=https://www.lvluoxinli.com/untitle1d.html'
          frameborder="0" allowfullscreen="true" scrolling="yes" height="500px" width="500px"> </iframe>
      </a-modal>


    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import axios from 'axios'
import URL from '@/store/url'
export default {
  name: 'LoginView',
  data () {
    return {
      radio: '1',
      distance: 15,
      username: '',
      password: '',
      loginDisable: false,
      errorNumber:4,
      qr:false,
      urlParams: null,
      info: '页面加载中，请稍后~',
      qudao: ['ncmhc.lvluoxinli.com'],
      title: '绿萝心理云平台'
    }
  },
  computed: {
    ...mapState([
      'isLogin',
      'teacherAdmin',
      'userInfo',
      'loginFlag'
    ])
  },
  methods: {
    ...mapMutations([
      'setGradesMaxMin',
      'setIsLogin',
      'setFresh',
      'setUserName',
      'setLoginInfo'
    ]),
    ...mapActions([
      'getLogin',
      'getUserInfo',
      'getEndTime'
    ]),
    onChange (e) {
      this.radio = e.target.value
    },
    openLink (){
      this.qr=true
    },
    async userLogin () {
      this.loginDisable = true
      if (this.username === '' || this.password === ''){
        this.loginDisable = false
        this.$message.error('请核对您输入的信息~')
        return
      }
      if (this.password.length < 6) {
        this.loginDisable = false
        this.$message.error('登录超时，请联系工作人员')
        return
      }
      try {
        const res = await this.getLogin({username: this.username, password: this.password}) // 登录
        if (this.isLogin === '联系平台客服解锁账号，或者等待1小时后解锁账号') {
          this.$message.error('联系平台客服解锁账号，或者等待30分钟后解锁账号')
          this.loginDisable = false
          return
        }
        let { success, data } = res.data

        if (success && !res.data.data.TOKEN) {
          this.loginDisable = false
          this.$message.error('登录失败')
          return
        }
        if (!success) {
          this.$message.error(`您还有${data.data.available_num}次尝试登录的机会。请确保您输入的账号和密码无误再尝试登录！`)
          this.loginDisable = false
          return
        }

        sessionStorage.setItem('teacherAdmin', JSON.stringify(this.teacherAdmin))
        await this.getUserInfo() // 详细信息
        await this.getEndTime() // 到期续费
        if (this.userInfo) {
          if (this.userInfo.city === 5203001232323) {
            sessionStorage.clear();
            this.$message.warning('因系统升级，7月10日之前进入升级维护期')
          } else {
            this.$message.success('登录成功', 1)
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            if (userInfo.max_grade && userInfo.min_grade) { // 判断是否设置年级范围
              let gradeList = [userInfo.min_grade, userInfo.max_grade]
              this.setGradesMaxMin(gradeList)
              sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
              this.$router.push('/deskView')
            } else{
              this.$router.push('/initView')
            }
          }
        } else {
          this.$message.error('此账号没有权限~')
        }

      } catch (e) {
        console.log(e)
        this.loginDisable = false
        this.$message.error('当前您的网络情况不佳，请刷新或稍后再试~')
      }
    }
  },
   async mounted () {
    // 渠道自动登录
    this.urlParams = window.location.href.split('?')[1]
    if (this.urlParams) {
      // 地址栏带参数
      // 设置浏览器标题和图标
      // 生产环境tenant=74a84264-72f5-448e-868d-c9fb00be9d25
      let {data} = await axios({
        method: "get",
        url: `${URL.QUDAO}tenant=a91ffc2b-24c0-4aad-b11a-9d3b36758e6d&dataId=${window.location.host}&group=qudao`
      })
      sessionStorage.setItem('qudao', JSON.stringify(data))
      document.querySelector('link[rel="icon"]').href = data.logo_url
      document.querySelector('title').innerHTML = data.qudao_name
      // 登录操作
      let arrParams = this.urlParams.split('&')
      let obj = {}
      for(let i = 0; i < arrParams.length; i++) {
        let arr = arrParams[i].split('=');
        obj[arr[0]] = arr[0] === 'UID' ? parseInt(arr[1]) : arr[1]
      }
      if (obj.UID && obj.TOKEN && obj.JWT && obj.USERNAME && obj.PASSWORD) {
        this.setIsLogin(true)
        this.setFresh(true)
        this.setUserName({username: obj.USERNAME, password: obj.PASSWORD})
        this.setLoginInfo({data: obj})
        sessionStorage.setItem('isLogin', true)
        sessionStorage.setItem('teacherAdmin', JSON.stringify(this.teacherAdmin))
        await this.getUserInfo() // 详细信息
        if (this.userInfo) {
          this.$message.success('登录成功')
          let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          if (userInfo.max_grade && userInfo.min_grade) { // 判断是否设置年级范围
            let gradeList = [userInfo.min_grade, userInfo.max_grade]
            this.setGradesMaxMin(gradeList)
            sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
            this.$router.push('/deskView')
          } else{
            this.$router.push('/initView')
          }
        } else {
          this.$message.error('此账号没有权限~')
        }
      } else {
        this.info = '登录失败，请退出重试~'
        this.$message.error('登录失败，请退出重试~')
      }
    }
    // 渠道非自动登录
    let url = window.location.host
    if (this.qudao.includes(url)) {
      let {data} = await axios({
        method: "get",
        url: `${URL.QUDAO}tenant=74a84264-72f5-448e-868d-c9fb00be9d25&dataId=${window.location.host}&group=qudao`
      })
      this.title = data.qudao_name
      sessionStorage.setItem('qudao', JSON.stringify(data))
    }
  }
}
</script>

<style>
p{
  display: block;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.login{
  display: flex;
  height: 100%;
  position: relative;
  background: #F8F9FB;
}
.login .info {
  width: 100%;
  font-size: 24px;
  text-align: center;
  padding-top: 100px;
}
.login > p {
  position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);position: absolute;
  bottom: 20px;
  left: 50%;
  color: #999;
  transform: translateX(-50%);
}
.login .backgroundImg{
  width: 460px;
  height: auto;
  background: url('../../assets/background.png');
  background-size: cover;
  position: relative;
}

.login .backgroundImg .loginPhoto{
  width: 400px;
  height: auto;
  right: 0px;
  bottom: 40px;
  position: absolute;
}

.loginContent{
  flex: 1;
  height: auto;
  background:#FFFFFF;
  position: relative;
}
.loginContent .remark{
  position: absolute;
  width: 100%;
  bottom: 10px;
  font-size:14px;
  color:rgba(153,153,153,1);
  line-height:14px;
  text-align: center;
}
.loginContent .remark>p{
  padding-bottom: 10px;
}
.loginContent .ContentFrom{
  position: absolute;
  left: 50%;
  top: 50%;
  /* transform:translateY(-50%); */
  transform: translate(-50%, -50%);
}
.loginContent>p:first-child{
  font-size:18px;
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:18px;
  letter-spacing:1px;
  top: 50px;
  right: 60px;
  position: absolute;
}
.loginContent .ContentFrom>p:first-child{
  height:40px;
  font-size:40px;
  font-weight:600;
  color:rgba(0,0,0,1);
  line-height:40px;
}.loginContent .ContentFrom>p:nth-child(2){
  font-size:24px;
  font-weight:600;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 16px;
}.loginContent .ContentFrom>p:nth-child(3){
  width:144px;
  height:30px;
  font-size:18px;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:30px;
  margin-top: 50px;
}
.loginContent .ContentFrom .form{
  width: 360px;
}
.loginContent .loginIn{
  text-align: left;
}
.loginContent .loginIn button {
  width:210px;
  height:45px;
}
.loginContent .ant-form {
  width: 75%;
  /* margin: 0 auto; */
}
.login .ant-btn{
  width:210px;
  height:45px;
  background-color: #3c4e6a;
  border-radius:4px;
}
.login .ant-btn-primary{
  background:rgba(36,192,148,1);
  border-color: rgba(36,192,148,1);
  margin-top: 30px;
}
.login .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
.login .ant-input {
  border: none;
  border-radius:4px;
  /* border-bottom-color: rgba(192,196,204,1); */
  /* border-bottom-style: solid; */
  border-bottom-width: 1px;
  padding: 1px 15px;
  background: #F5F6F8;
  color: #999999;
  width:360px;
  height:45px;
}
.login .ant-input:hover{
  outline: none;
  border-bottom-color:#3c4f6a;
}
.login .ant-input:focus {
    border: none;
    /* border-bottom: 1px solid #3c4f6a !important; */
    box-shadow: none;
}
.login .ant-row.ant-form-item{
  top: 20px;
  margin-bottom: 20px;
}
.login a {
  text-decoration: underline;
}
.jgwablogo{
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url('../../assets/jgwab.png');
  position: relative;
  top: 3px;
}
.login .ant-btn-primary[disabled] {
  color: #FFFFFF;
}
.login .backgroundImg .login_logo {
  width: 250px;
  height: auto;
  position: absolute;
  left: 30px;
  top: 50px;
}
@media (max-width: 1200px){
    .login .backgroundImg {
      width:420px;
    }
  }
@media (max-width: 900px){
  /* .login .backgroundImg {
    display: none;
  } */
  .login {
    width: 900px;
  }
}
@media (max-height: 600px){
  .login {
    height: 600px;
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.outerLogin {
    /* position: relative; */
  width: 360px;
  height: 14px;
  margin-top: 40px;
}

 .section_2 {
  background-color: rgba(216, 216, 216, 1);
  width: 121px;
  height: 1px;
  margin-top: 6px;
}

.text_8 {
  width: 84px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 17px;
}

 .section_3 {
  background-color: rgba(216, 216, 216, 1);
  width: 121px;
  height: 1px;
  margin: 6px 0 0 17px;
}

/* 登录安不要 */

.block_2 {
  background-color: rgba(245, 246, 248, 1);
  border-radius: 8px;
  width: 180px;
  height: 46px;
  margin-top: 24px;
  cursor: pointer
}

.image-text_1 {
  width: 104px;
  height: 32px;
  margin: 7px 0 0 38px;
}

.label_1 {
  width: 32px;
  height: 32px;
}

.text-group_1 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(23, 26, 29, 1);
  font-size: 14px;
  font-weight: NaN;
  text-align: justify;
  white-space: nowrap;
  line-height: 14px;
  margin-top: 9px;
}

</style>
